import React, { useState, useEffect } from 'react';
import { Calendar } from 'primereact/calendar';

const ScienceScoringReferenceForm = ({ isOpen, onClose, formData, setFormData, toast, data, fetchData }) => {
    const [calcResult, setCalcResult] = useState(null);
    const [isCalculating, setIsCalculating] = useState(false);
    const [hasAutoSaved, setHasAutoSaved] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setCalcResult(null);
            setHasAutoSaved(false);
            if (!formData.ActionType) {
                setFormData(prev => ({ ...prev, ActionType: 'View' }));
            }
        }
    }, [isOpen, formData.ActionType, setFormData]);

    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newFormData = { ...formData, [name]: value };

        if (name === 'ScoringContent' && value === 'Article' && !newFormData.ArticleRanking) {
            newFormData.ArticleRanking = 'All';
        }

        setFormData(newFormData);
        setCalcResult(null);
        setHasAutoSaved(false);
    };

    const handleDateChange = (name, dateObj) => {
        let dateString = '';
        if (dateObj) {
            const yyyy = dateObj.getFullYear();
            const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
            const dd = String(dateObj.getDate()).padStart(2, '0');
            dateString = `${yyyy}-${mm}-${dd}`;
        }
        handleChange({ target: { name, value: dateString } });
    };

    const handleCalculate = async () => {
        if (formData.FromDate && formData.ToDate) {
            const fromDate = new Date(formData.FromDate);
            const toDate = new Date(formData.ToDate);
            if (fromDate > toDate) {
                toast?.current?.show({
                    severity: 'error',
                    summary: 'Lỗi ngày tháng',
                    detail: 'Từ ngày không được lớn hơn Đến ngày!',
                    life: 3000
                });
                return;
            }
        }
        setIsCalculating(true);
        try {
            const currentUser = JSON.parse(localStorage.getItem('user'));
            const accessToken = localStorage.getItem('accessToken');

            const payload = {
                ...formData,
                ArticleRanking: formData.ScoringContent === 'Article' ? (formData.ArticleRanking || 'All') : 'All',
                UserId: currentUser?.Id
            };

            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/referencescoring?action=calculatereference`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();

                if (result.status === 'error' || !result.Summary) {
                    toast?.current?.show({
                        severity: 'error',
                        summary: 'Lỗi tính toán',
                        detail: result.message || 'Dữ liệu trả về không hợp lệ!',
                        life: 4000
                    });
                    setIsCalculating(false);
                    return;
                }

                setCalcResult(result);

                if (formData.ActionType === 'Save') {
                    const finalData = {
                        ...formData,
                        ...result.Summary,
                        FromDate: formData.FromDate,
                        ToDate: formData.ToDate,
                        UserId: currentUser?.Id
                    };

                    if (!finalData.Id && data) {
                        const existingItem = data.find(d => d.FromDate?.split('T')[0] === finalData.FromDate && d.ToDate?.split('T')[0] === finalData.ToDate && d.Status === 'Tham khảo');
                        if (existingItem && existingItem.Status !== 'Đã duyệt') {
                            finalData.Id = existingItem.Id;
                        }
                    }

                    const saveResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/referencescoring`, {
                        method: finalData.Id ? 'PUT' : 'POST',
                        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` },
                        body: JSON.stringify(finalData)
                    });

                    if (saveResponse.ok) {
                        setHasAutoSaved(true);
                        toast?.current?.show({ severity: 'success', summary: 'Thành công', detail: 'Đã tự động lưu kết quả tham khảo vào hệ thống!' });
                        if (fetchData) fetchData(true);
                    } else {
                        toast?.current?.show({ severity: 'error', summary: 'Lỗi', detail: 'Tính điểm thành công nhưng không thể lưu!' });
                    }
                } else {
                    toast?.current?.show({ severity: 'success', summary: 'Thành công', detail: 'Đã tải dữ liệu bảng điểm dự kiến!' });
                }
            } else {
                toast?.current?.show({ severity: 'error', summary: 'Lỗi', detail: 'Lỗi HTTP hoặc Máy chủ từ chối kết nối!' });
            }
        } catch (error) {
            toast?.current?.show({ severity: 'error', summary: 'Lỗi', detail: 'Không thể kết nối đến máy chủ' });
        } finally {
            setIsCalculating(false);
        }
    };

    const handleSave = async () => {
        if (!calcResult || !calcResult.Summary) return;
        const currentUser = JSON.parse(localStorage.getItem('user'));
        const accessToken = localStorage.getItem('accessToken');

        const finalData = {
            ...formData,
            ...calcResult.Summary,
            FromDate: formData.FromDate,
            ToDate: formData.ToDate,
            UserId: currentUser?.Id
        };

        if (!finalData.Id && data) {
            const existingItem = data.find(d => d.FromDate?.split('T')[0] === finalData.FromDate && d.ToDate?.split('T')[0] === finalData.ToDate && d.Status === 'Tham khảo');
            if (existingItem && existingItem.Status !== 'Đã duyệt') {
                finalData.Id = existingItem.Id;
            }
        }

        try {
            const saveResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/referencescoring`, {
                method: finalData.Id ? 'PUT' : 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` },
                body: JSON.stringify(finalData)
            });

            if (saveResponse.ok) {
                toast?.current?.show({ severity: 'success', summary: 'Thành công', detail: 'Đã lưu kết quả tham khảo!' });
                if (fetchData) fetchData(true);
                onClose();
            } else {
                toast?.current?.show({ severity: 'error', summary: 'Lỗi', detail: 'Không thể lưu bản ghi!' });
            }
        } catch (e) {
            toast?.current?.show({ severity: 'error', summary: 'Lỗi', detail: 'Không thể kết nối máy chủ' });
        }
    };

    return (
        <div className="modal-overlay" style={{ zIndex: 1000 }}>
            <div className="modal-box form-modal-box" style={{ maxHeight: '95vh', overflowY: 'auto' }}>

                <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <h3 style={{ margin: 0, paddingRight: '15px', lineHeight: '1.4', color: '#e67e22' }}>
                        <i className="fa-solid fa-calculator" style={{ marginRight: '8px' }}></i>
                        Tính Điểm Khoa Học (Tham Khảo)
                    </h3>
                    <button className="close-btn" onClick={onClose} style={{ fontSize: '26px', lineHeight: '1', display: 'flex', flexShrink: 0, marginTop: '-2px' }}>
                        &times;
                    </button>
                </div>

                <div className="modal-body" style={{ padding: '25px' }}>

                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginBottom: '20px' }}>

                        <div className="form-group" style={{ flex: '1 1 250px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Nội dung tính điểm</label>
                            <select name="ScoringContent" className="form-input" value={formData.ScoringContent} onChange={handleChange}>
                                <option value="All">Tất cả công trình</option>
                                <option value="Article">Bài báo</option>
                                <option value="Project">Đề tài</option>
                                <option value="Book">Sách - Giáo trình</option>
                                <option value="Other">Nội dung NCKH Khác</option>
                            </select>
                        </div>

                        {formData.ScoringContent === 'Article' && (
                            <div className="form-group" style={{ flex: '1 1 250px' }}>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#0056b3' }}>Phân loại Q-Ranking</label>
                                <select name="ArticleRanking" className="form-input" value={formData.ArticleRanking || 'All'} onChange={handleChange} style={{ border: '1px solid #0056b3', backgroundColor: '#f8fbff' }}>
                                    <option value="All">Tất cả bài báo</option>
                                    <option value="Q1">Tạp chí Q1</option>
                                    <option value="Q2">Tạp chí Q2</option>
                                    <option value="Q3">Tạp chí Q3</option>
                                    <option value="Q4">Tạp chí Q4</option>
                                    <option value="Other">Tạp chí khác / Trong nước</option>
                                </select>
                            </div>
                        )}

                        <div className="form-group" style={{ flex: '1 1 250px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Trạng thái (Bộ lọc)</label>
                            <select name="ItemStatusFilter" className="form-input" value={formData.ItemStatusFilter} onChange={handleChange}>
                                <option value="All">Tất cả trạng thái (Bao gồm Nháp)</option>
                                <option value="Approved">Chỉ lấy Đã duyệt</option>
                                <option value="Pending">Đã gửi duyệt</option>
                                <option value="Draft">Đang chỉnh sửa</option>
                            </select>
                        </div>

                        <div className="form-group" style={{ flex: '1 1 250px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Hệ số</label>
                            <input type="number" step="0.1" name="Coefficient" className="form-input" value={formData.Coefficient} onChange={handleChange} />
                        </div>

                        <div className="form-group" style={{ flex: '1 1 250px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Hành động *</label>
                            <select name="ActionType" className="form-input" value={formData.ActionType || 'View'} onChange={handleChange}>
                                <option value="View">Chỉ xem bảng điểm tham khảo</option>
                                <option value="Save">Xem và lưu với status Tham khảo</option>
                            </select>
                        </div>

                        <div className="form-group" style={{ flex: '1 1 250px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Từ ngày</label>
                            <Calendar
                                id="FromDateRef"
                                name="FromDate"
                                value={(formData.FromDate && !isNaN(new Date(formData.FromDate).getTime())) ? new Date(formData.FromDate) : null}
                                dateFormat="dd/mm/yy"
                                showIcon
                                onChange={(e) => handleDateChange('FromDate', e.value)}
                                style={{ width: '100%' }}
                                appendTo={document.body}
                                panelStyle={{ marginTop: '5px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', borderRadius: '8px', zIndex: 99999 }}
                                inputStyle={{ padding: '10px 12px', border: '1px solid #cbd5e1', borderRight: 'none', borderRadius: '6px 0 0 6px', fontSize: '14px', outline: 'none' }}
                            />
                        </div>

                        <div className="form-group" style={{ flex: '1 1 250px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Đến ngày</label>
                            <Calendar
                                id="ToDateRef"
                                name="ToDate"
                                value={(formData.ToDate && !isNaN(new Date(formData.ToDate).getTime())) ? new Date(formData.ToDate) : null}
                                dateFormat="dd/mm/yy"
                                showIcon
                                onChange={(e) => handleDateChange('ToDate', e.value)}
                                style={{ width: '100%' }}
                                appendTo={document.body}
                                panelStyle={{ marginTop: '5px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', borderRadius: '8px', zIndex: 99999 }}
                                inputStyle={{ padding: '10px 12px', border: '1px solid #cbd5e1', borderRight: 'none', borderRadius: '6px 0 0 6px', fontSize: '14px', outline: 'none' }}
                            />
                        </div>

                    </div>

                    {calcResult && calcResult.Summary && (
                        <div style={{ borderTop: '1px solid #eee', paddingTop: '20px', marginTop: '10px' }}>

                            <div style={{
                                backgroundColor: '#fff3cd',
                                padding: '12px 15px',
                                borderRadius: '6px',
                                marginBottom: '15px',
                                borderLeft: '4px solid #f39c12',
                                fontSize: '14px',
                                color: '#856404'
                            }}>
                                <i className="fa-solid fa-circle-info" style={{ marginRight: '8px' }}></i>
                                <strong>Cơ chế tính điểm tham khảo: </strong>
                                {calcResult.Summary.AppliedConfigVersionName || 'Mặc định'}
                            </div>

                            <h4 style={{ color: '#e67e22', marginBottom: '10px', textTransform: 'uppercase', fontSize: '14px' }}>
                                TỔNG HỢP SỐ GIỜ NGHIÊN CỨU KHOA HỌC DỰ KIẾN
                            </h4>
                            <div style={{ overflowX: 'auto', marginBottom: '30px' }}>
                                <table className="custom-table" style={{ width: '100%', textAlign: 'center' }}>
                                    <thead style={{ backgroundColor: '#f8f9fa' }}>
                                        <tr>
                                            <th style={{ textAlign: 'center' }}>Chức danh</th>
                                            <th style={{ textAlign: 'center' }}>Định mức chuẩn (giờ)</th>
                                            <th style={{ textAlign: 'center' }}>Tỉ lệ giảm (%)</th>
                                            <th style={{ textAlign: 'center' }}>Cần đạt (giờ)</th>
                                            <th style={{ textAlign: 'center' }}>Tổng điểm (điểm)</th>
                                            <th style={{ textAlign: 'center' }}>Hệ số</th>
                                            <th style={{ textAlign: 'center' }}>Số giờ quy đổi (giờ)</th>
                                            <th style={{ textAlign: 'center' }}>Chênh lệch (giờ)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{calcResult.Summary.JobTitle}</td>
                                            <td>{calcResult.Summary.StandardHours}</td>
                                            <td style={{ textAlign: 'center' }}>
                                                {Math.round(Number(calcResult.Summary.ReductionPercentage) * 100) / 100}
                                            </td>
                                            <td style={{ fontWeight: 'bold', color: '#e67e22' }}>
                                                {Math.round(Number(calcResult.Summary.RequiredHours) * 100) / 100}
                                            </td>
                                            <td style={{ fontWeight: 'bold' }}>
                                                {Math.round(Number(calcResult.Summary.AchievedScore) * 100) / 100}
                                            </td>
                                            <td>{calcResult.Summary.Coefficient}</td>
                                            <td style={{ fontWeight: 'bold' }}>{calcResult.Summary.ConvertedHours}</td>
                                            <td style={{ color: calcResult.Summary.DifferenceHours >= 0 ? '#28a745' : '#dc3545', fontWeight: 'bold' }}>
                                                {Math.round(Number(calcResult.Summary.DifferenceHours) * 100) / 100}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h4 style={{ color: '#555', marginBottom: '10px', textTransform: 'uppercase', fontSize: '14px' }}>
                                CHI TIẾT CÔNG TRÌNH DỰ KIẾN
                            </h4>
                            <div style={{ overflowX: 'auto' }}>
                                <table className="custom-table" style={{ width: '100%', textAlign: 'center' }}>
                                    <thead style={{ backgroundColor: '#f8f9fa' }}>
                                        <tr>
                                            <th style={{ textAlign: 'center' }}>STT</th>
                                            <th style={{ textAlign: 'left' }}>Loại</th>
                                            <th style={{ textAlign: 'left' }}>Tiêu đề</th>
                                            <th style={{ textAlign: 'left' }}>Nơi đăng/Cấp</th>
                                            <th style={{ textAlign: 'center' }}>Ngày NT/XB</th>
                                            <th style={{ textAlign: 'left' }}>Tác giả</th>
                                            <th style={{ textAlign: 'center' }}>Số điểm</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {calcResult.Details && calcResult.Details.length > 0 ? (
                                            calcResult.Details.map((d, idx) => (
                                                <tr key={idx}>
                                                    <td style={{ textAlign: 'center' }}>{idx + 1}</td>
                                                    <td style={{ fontWeight: 'bold', color: '#666', fontSize: '13px', whiteSpace: 'nowrap', textAlign: 'left' }}>{d.Type}</td>
                                                    <td style={{ width: '30%', textAlign: 'left' }}>{d.Title}</td>
                                                    <td style={{ textAlign: 'left' }}>{d.Journal}</td>
                                                    <td style={{ textAlign: 'center' }}>{d.PublishDate}</td>
                                                    <td style={{ fontSize: '12px', textAlign: 'left' }}>{d.Authors}</td>
                                                    <td style={{ fontWeight: 'bold', color: '#0056b3', textAlign: 'center' }}>{d.Score}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="7" style={{ textAlign: 'center', padding: '20px', color: '#888' }}>
                                                    Không có dữ liệu trong khoảng thời gian này
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>

                <div className="modal-footer" style={{ borderTop: '1px solid #eee', padding: '15px 25px' }}>
                    <button type="button" className="btn-cancel" onClick={onClose}>
                        {hasAutoSaved ? 'Đóng' : 'Hủy'}
                    </button>
                    <button
                        type="button"
                        className="btn-submit"
                        style={{
                            backgroundColor: '#f39c12',
                            opacity: (!formData.FromDate || !formData.ToDate) ? 0.6 : 1,
                            cursor: (!formData.FromDate || !formData.ToDate) ? 'not-allowed' : 'pointer'
                        }}
                        onClick={handleCalculate}
                        disabled={!formData.FromDate || !formData.ToDate || isCalculating}
                    >
                        {isCalculating ? (
                            <><i className="fa-solid fa-circle-notch fa-spin" style={{ marginRight: '6px' }}></i>Đang tính</>
                        ) : 'Tính điểm tham khảo'}
                    </button>
                    {calcResult && calcResult.Summary && !hasAutoSaved && formData.ActionType === 'View' && (
                        <button type="button" className="btn-submit" style={{ backgroundColor: '#28a745' }} onClick={handleSave}>
                            Lưu kết quả
                        </button>
                    )}
                </div>

            </div>
        </div>
    );
};

export default ScienceScoringReferenceForm;